import deviceAdvFreq from '../../utils/deviceAdvFreq';
import gptTools from '../../utils/gptTools';
import tmsTools from '../../utils/tmsTools';

export const gptPrintLog = function (log, obj) {
    if (!gptTools.logs) {
        gptTools.logs = [];
    }

    // Store the log entry with a timestamp
    const timestamp = new Date().toISOString();
    const logEntry = {
        timestamp,
        log,
        obj: typeof obj === 'undefined' ? null : obj,
    };
    gptTools.logs.push(logEntry);

    // GPT TAG X.XX - log
    try {
        if (typeof obj === 'undefined' && log.match(/GPT TAG (.*) - /)) {
            log = log.replace('GPT TAG', '');
            obj = log.match('(.*?)-(.*)')[2].trim();
            log = log.match('(.*?)-(.*)')[1].trim();

            if (!gptTools.version) {
                gptTools.version = log;
                gptTools.commit = obj;
            }
        }
    } catch (_) {}

    if (tmsTools.getCookie('gptPrintLog') === '1') {
        const style = 'color: #4285F4; font-weight: bold;';

        if (typeof obj === 'undefined') {
            console.log('%c[GPT TAG]', style, log);
        } else {
            console.log(`%c[GPT TAG]%c ${log}:`, style, 'color: #000; font-weight: bold;', obj);
        }
    }
};

export const getParameterByNameKwUrlSwitchAdv = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const dfpCheckSite = function (site) {
    return window.RCSAD_sitepage.toLowerCase().indexOf(site.toLowerCase()) > -1;
};

export const isInViewportAdvBox = function (elem) {
    const distance = elem.getBoundingClientRect();
    return (
        distance.top >= 0 &&
        distance.left >= 0 &&
        distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        distance.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

export const initializeSkyscraper = function (id, position) {
    const skyScraper = document.getElementById(id);
    try {
        let zIndexValue = '0';
        const isQuestoQuello = window.location.href.indexOf('questoquello.gazzetta.it') > -1;
        if (isQuestoQuello) {
            zIndexValue = '9999';
        }

        skyScraper.style.cssText += 'position: fixed; z-index: ' + zIndexValue + '; top: 6%;';
        if (position === 'right') {
            skyScraper.style.cssText += 'right: 0;';
        }
    } catch (_) {
        console.error('skyscraper element not found');
    }
};

export const isTodayTheDay = function (days) {
    const today = new Date();
    return days.some((dateString) => {
        const date = new Date(dateString);
        return date.toDateString() === today.toDateString();
    });
};

export const sizeNormalizer = function (sizes) {
    // Allow mono size native slots to be passed
    if (!Array.isArray(sizes)) return sizes;

    return sizes.filter(
        (size) =>
            !(
                (
                    size[0] !== 1 &&
                    size[1] !== 1 && // Keep fluid 1x1
                    Number(size[1].toString().slice(-1)) !== 0
                ) // Normalize sizes (le size con 1 finale es 300x251)
            )
    );
};

export const getDevice = function () {
    const isApp = document.location.href.includes('app_v1=true') || document.location.href.includes('app_v2=true');

    if (isApp) return 'APP';
    if (deviceAdvFreq.tablet()) return 'Tablet';
    if (deviceAdvFreq.mobile()) return 'Mobile';

    return 'Desktop';
};
